<script setup lang="ts">
import type { ArticleContent } from '~/models/Content/ArticleContent'
import { computed } from 'vue'
import RichTextRenderer from '~/components/utils/RichTextRenderer.vue'
import Image from '~/components/media/Image.vue'

const { articleContent } = defineProps<{ articleContent: ArticleContent }>()
const mediaContentId = computed(() => Number(articleContent.svg?.destinationContentId ?? articleContent.image?.destinationContentId ?? 0))
</script>

<template>
  <div class="col-[fill] grid h-lvh grid-cols-subgrid items-center bg-(--theme-pop) last:mb-[calc(var(--col-width)*-1)]">
    <div class="col-[text] flex flex-col items-center gap-(--col-width) py-(--col-width)">
      <Image
        v-if="mediaContentId > 0"
        :content="mediaContentId"
        width="400px"
        class="!w-[20ch]"
      />
      <div class="text-center">
        <h2>{{ articleContent.title }}:</h2>
        <div class="au-bigtext">
          <RichTextRenderer
            v-if="articleContent.body"
            :text="articleContent.body"
          />
        </div>
      </div>
    </div>
  </div>
</template>
